export enum PaymentType {
  POINTS = 'POINTS',
  DEBIT_CARD = 'DEBIT_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  ALIPAY = 'ALIPAY',
  ALIPAY_WAP = 'ALIPAY_WAP',
  BANK = 'BANK',
  IDEAL = 'IDEAL',
  WECHAT = 'WECHAT',
  UNIONPAY = 'UNIONPAY',
  SOFORT = 'SOFORT',
  PAYPAL = 'PAYPAL',
  KLARNA = 'KLARNA',
  KLARNA_ACCOUNT = 'KLARNA_ACCOUNT',
  NORDEA = 'NORDEA',
  NORDEA_ECREDIT = 'NORDEA_ECREDIT',
  NORDEA_SE = 'NORDEA_SE',
  NORDEA_EE = 'NORDEA_EE',
  SAMPO = 'SAMPO',
  OKO = 'OKO',
  HANDELSBANKEN = 'HANDELSBANKEN',
  ALANDSBANKEN = 'ALANDSBANKEN',
  SPANKKI = 'SPANKKI',
  AKTIA = 'AKTIA',
  SP = 'SP',
  POP = 'POP',
  VIPPS = 'VIPPS',
  SWISH = 'SWISH',
  GIROPAY = 'GIROPAY',
  UNKNOWN = 'UNKNOWN',
  GIFT_CARD = 'GIFT_CARD',
  MOBILE_PAY = 'MOBILE_PAY',
  TRUSTLY = 'TRUSTLY',
  ADYEN_PAYMENT_CARD = 'ADYEN_PAYMENT_CARD',
  INDIA_NETBANKING = 'INDIA_NETBANKING',
  INDIA_UPI = 'INDIA_UPI',
  INDIA_WALLET = 'INDIA_WALLET',
}

export enum PaymentSubType {
  AX = 'AX',
  AY = 'AY',
  CA = 'CA',
  DC = 'DC',
  JC = 'JC',
  TP = 'TP',
  VI = 'VI',
  DS = 'DS',
  // Temporary duplicate due to new model
  NORDEA = 'NORDEA',
  NORDEA_ECREDIT = 'NORDEA_ECREDIT',
  NORDEA_SE = 'NORDEA_SE',
  NORDEA_EE = 'NORDEA_EE',
  SAMPO = 'SAMPO',
  OKO = 'OKO',
  HANDELSBANKEN = 'HANDELSBANKEN',
  ALANDSBANKEN = 'ALANDSBANKEN',
  SPANKKI = 'SPANKKI',
  AKTIA = 'AKTIA',
  SP = 'SP',
  POP = 'POP',
}

export interface OrderPayment {
  id: string;
  mopSubType: PaymentSubType;
  mopType: PaymentType;
}
